{
  "intro": "One address in front of several servers: each service listens on a port and forwards to a port of the targets, only to the ones that pass the health check. Billed by the hour up to a monthly cap.",
  "empty": "No load balancers yet",
  "emptyLead": "A load balancer spreads traffic over several servers and stops sending it to a server that fails its health check, so one server can go down without the site going down.",
  "create": "Create load balancer",
  "newTitle": "New load balancer",
  "newIntro": "Pick a location and a size, then what it forwards and to which servers. Services and targets can be changed later.",
  "back": "All load balancers",
  "notFound": "This load balancer no longer exists.",
  "open": "Open",
  "name": "Name",
  "nameHint": "To recognise it in lists, for example by the site it serves.",
  "type": "Type",
  "location": "Location",
  "zone": "Network zone {{zone}}",
  "algorithm": "Algorithm",
  "algorithms": {
    "round_robin": "Round robin",
    "least_connections": "Least connections"
  },
  "algorithmHints": {
    "round_robin": "Each new connection goes to the next target in turn.",
    "least_connections": "Each new connection goes to the target with the fewest open connections."
  },
  "algorithmSave": "Save algorithm",
  "algorithmSaving": "Changing the algorithm…",
  "healthTitle": "Health",
  "health": {
    "healthy": "Healthy",
    "unhealthy": "Unhealthy",
    "partial": "Partly healthy",
    "unknown": "Not checked yet",
    "none": "Nothing to check"
  },
  "healthOnPort": "{{port}}: {{status}}",
  "healthyOf": "Healthy: {{healthy}} of {{count}}",
  "healthLead": "The balancer checks every target on each service's health check and sends traffic only to targets that pass.",
  "openTargets": "Open targets",
  "address": "Address",
  "addresses": "Addresses",
  "privateOnly": "Private networks only",
  "services": "Services",
  "noServices": "No services",
  "noServicesLead": "A service makes the balancer listen on a port and forward to a port of the targets, for example 443 → 8443.",
  "servicesLead": "What the balancer listens on and where it forwards. This type holds up to {{max}} services.",
  "targets": "Targets",
  "targetsCount": "Targets: {{count}}",
  "targetsLead": "Where traffic goes. This type holds up to {{max}} targets; each server a label selector matches counts.",
  "noTargets": "No targets",
  "noTargetsLead": "Add the servers the balancer should send traffic to: one by one, by label, or by IP address.",
  "target": "Target",
  "targetKind": "Kind",
  "targetKinds": {
    "server": "Server",
    "label_selector": "Label selector",
    "ip": "IP address"
  },
  "via": "Reached over",
  "viaPrivate": "Private network",
  "viaPublic": "Public address",
  "viaIp": "This address",
  "addServer": "Add server",
  "addSelector": "Add by label",
  "addIp": "Add IP address",
  "addTarget": "Add target",
  "addTargetLead": {
    "server": "Servers of network zone {{zone}} can be targets.",
    "selector": "Every server of network zone {{zone}} whose labels match becomes a target, also servers created later.",
    "ip": "An address outside this project, for example a dedicated server. It is reached over the Internet."
  },
  "server": "Server",
  "serverHint": "Traffic reaches it on each service's destination port.",
  "chooseServer": "Choose a server",
  "selectorHint": "For example role=web, or env in (prod,staging).",
  "ip": "IP address",
  "ipHint": "IPv4 or IPv6.",
  "usePrivateIp": "Use the private address",
  "usePrivateIpHint": "Traffic to the targets stays in the private network, so they need no open public ports.",
  "usePrivateIpNeedsNetwork": "Needs a private network that the balancer and the server share.",
  "targetAdding": "Adding the target…",
  "targetRemoving": "Removing the target…",
  "removeTarget": "Remove target",
  "removeTargetTitle": "Remove {{name}} from the balancer?",
  "removeTargetConsequence": "The balancer stops sending traffic there; the server itself is not changed.",
  "labelSelectors": "Label selectors",
  "labelSelectorsHint": "One per line, for example role=web. Matching servers of the zone become targets.",
  "noServersInProject": "The project has no servers yet; add targets later.",
  "publicInterface": "Public interface",
  "publicInterfaceHint": "Reachable from the Internet on its own IPv4 and IPv6. Off, it serves only its private networks.",
  "on": "On",
  "off": "Off",
  "enablePublic": "Turn on public interface",
  "disablePublic": "Turn off public interface",
  "enablePublicTitle": "Make the balancer reachable from the Internet?",
  "enablePublicConsequence": "Its services answer on its public addresses again.",
  "disablePublicTitle": "Take the balancer off the Internet?",
  "disablePublicConsequence": "Its public addresses stop answering; it serves only its private networks.",
  "publicSwitching": "Changing the public interface…",
  "network": "Private network",
  "networks": "Private networks",
  "networksLead": "Networks the balancer has an address in; it reaches targets over them.",
  "networkHint": "Optional. Needed to reach targets over private addresses, or to serve without the public interface.",
  "noNetwork": "No private network",
  "noNetworkLead": "The balancer is in no private network.",
  "chooseNetwork": "Choose a network",
  "attach": "Attach to network",
  "attachTitle": "Attach to a private network",
  "attachLead": "Networks with a subnet in network zone {{zone}} fit.",
  "attaching": "Attaching to the network…",
  "fixedIp": "Address (optional)",
  "fixedIpHint": "Leave empty to take a free address of the subnet.",
  "privateIp": "Address",
  "detach": "Detach",
  "detachTitle": "Detach from {{name}}?",
  "detachConsequence": "Targets reached over this network can no longer be reached through it.",
  "detaching": "Detaching from the network…",
  "dnsV4": "Reverse DNS of IPv4",
  "dnsV6": "Reverse DNS of IPv6",
  "limitsTitle": "Type and limits",
  "maxConnections": "Connections at most",
  "trafficOut": "Traffic out this month",
  "trafficIncluded": "{{size}} included",
  "price": "Per month",
  "pricePerHour": "Per hour",
  "pricePerMonth": "Per month, at most",
  "pricePair": "{{hourly}} per hour, {{monthly}} per month at most",
  "notOffered": "Not offered in this location",
  "billing": "Billed by the hour from creation until deletion, up to the monthly price; traffic above the included amount costs extra.",
  "typeLimits": "{{services}} services, {{targets}} targets, {{certificates}} certificates",
  "typeConnections": "Up to {{count}} connections at once",
  "changeType": "Change type",
  "changeTypeLead": "A larger type takes more services, targets and connections; the balancer keeps its addresses.",
  "changeTypeSubmit": "Change type",
  "typeChanging": "Changing the type…",
  "summary": "Summary",
  "submit": "Create load balancer",
  "created": "Load balancer {{name}} is being created",
  "createdAt": "Created",
  "fixErrors": "Some values need attention; see the marked fields.",
  "stepLocation": "Location",
  "stepLocationLead": "Where the balancer runs. It sends traffic to servers of the same network zone.",
  "stepType": "Size",
  "stepTypeLead": "How many services, targets and connections it handles.",
  "stepNetwork": "Network",
  "stepNetworkLead": "Public, private, or both.",
  "stepAlgorithm": "Algorithm",
  "stepService": "First service",
  "stepServiceLead": "What it listens on and where it forwards; more can be added later.",
  "withService": "Add a service now",
  "stepTargets": "Targets",
  "stepTargetsLead": "The servers that receive the traffic.",
  "stepName": "Name and labels",
  "saved": "Saved",
  "protect": "Protect from deletion",
  "unprotect": "Remove delete protection",
  "protected": "Protected",
  "running": "A change is running:",
  "delete": "Delete load balancer",
  "deleteTitle": "Delete load balancer {{name}}?",
  "deleteAddresses": "Its address {{address}} is released and cannot be brought back.",
  "deleteServices": "All its services stop at once.",
  "deleteTargets": "The target servers are not changed; they stop getting traffic through it.",
  "deleteBilling": "Billing stops with the current hour.",
  "deleteProtected": "Delete protection is on. Turn it off first.",
  "deleted": "Load balancer {{name}} deleted",
  "why": {
    "protected": "Delete protection is on",
    "otherZone": "Another network zone",
    "alreadyTarget": "Already a target",
    "joined": "Already attached",
    "noSubnet": "No subnet in the balancer's zone",
    "currentType": "Current type",
    "tooSmall": "Too small for its services, targets or certificates"
  },
  "tabs": {
    "overview": "Overview",
    "services": "Services",
    "targets": "Targets",
    "networking": "Networking",
    "type": "Change type",
    "settings": "Name and labels",
    "delete": "Delete"
  },
  "tabIntro": {
    "overview": "Addresses, health, algorithm and limits.",
    "services": "Ports the balancer listens on and the ports of the targets it forwards to.",
    "targets": "Servers and addresses that receive the traffic, with their health per service.",
    "networking": "The public interface and the private networks.",
    "type": "The size of the balancer.",
    "settings": "Name and labels.",
    "delete": "Delete the balancer and release its addresses."
  },
  "service": {
    "add": "Add service",
    "addTitle": "Add a service",
    "editTitle": "Service on port {{port}}",
    "lead": "Listen on port A, forward to port B of every healthy target.",
    "adding": "Adding service {{listen}} → {{destination}}…",
    "saving": "Saving service {{listen}} → {{destination}}…",
    "edit": "Edit",
    "delete": "Delete service",
    "deleteTitle": "Delete service {{service}}?",
    "deleteStops": "The balancer stops answering on port {{port}}.",
    "deleting": "Deleting the service…",
    "forward": "Listens → forwards to",
    "forwardSummary": "Clients connect to port {{listen}}; the balancer forwards to port {{destination}} of the targets.",
    "protocol": "Protocol",
    "protocolHints": {
      "tcp": "Forwards connections as they are, for any protocol (TLS passes through untouched).",
      "http": "Reads HTTP requests: sticky sessions and HTTP health checks are possible.",
      "https": "Ends TLS on the balancer with your certificate and forwards plain HTTP to the targets."
    },
    "listenPort": "Listen port",
    "listenHint": "Where clients connect.",
    "listenFixed": "A service keeps its listen port; add a new service for another one.",
    "destinationPort": "Destination port",
    "destinationHint": "Where the targets receive the traffic.",
    "portInvalid": "A port from 1 to 65535.",
    "certificates": "Certificates",
    "certificatesHint": "The certificate the balancer presents for HTTPS; several cover several domains.",
    "noCertificates": "The project has no certificates yet.",
    "openCertificates": "Add a certificate",
    "certificateNeeded": "Choose at least one certificate.",
    "redirectHttp": "Redirect HTTP to HTTPS",
    "redirectHttpHint": "Plain requests on port 80 get a redirect to this service. Port 80 must be free.",
    "sticky": "Sticky sessions",
    "stickyHint": "A cookie keeps each client on the same target.",
    "proxyProtocol": "PROXY protocol",
    "proxyProtocolHint": "Passes the client's address to the targets; they must expect it, or they reject the traffic.",
    "options": "Options",
    "redirectShort": "HTTP → HTTPS",
    "stickyShort": "Sticky",
    "proxyShort": "PROXY",
    "healthCheck": "Health check",
    "healthCheckHint": "How the balancer finds out a target can take traffic. A target that fails the check gets none until it passes again.",
    "checkSummary": "{{protocol}} on port {{port}} {{path}}, every {{interval}}\u00a0s",
    "moreCheck": "Change check",
    "lessCheck": "Hide",
    "checkProtocol": "Check protocol",
    "checkPort": "Check port",
    "interval": "Interval, seconds",
    "timeout": "Timeout, seconds",
    "retries": "Retries",
    "retriesHint": "Failed checks in a row before a target counts as unhealthy.",
    "secondsInvalid": "A whole number of seconds.",
    "retriesInvalid": "A whole number, 0 or more.",
    "path": "Path",
    "pathInvalid": "Starts with /.",
    "domain": "Host header",
    "domainHint": "Optional: the domain sent with the check.",
    "statusCodes": "Accepted status codes",
    "statusCodesHint": "Comma-separated; ? matches any digit, e.g. 2??, 301.",
    "codesInvalid": "Codes such as 200 or 2??.",
    "response": "Expected text",
    "responseHint": "Optional: the answer must contain it.",
    "tls": "Check over HTTPS",
    "tlsHint": "For targets that answer only HTTPS on the check port.",
    "cookieName": "Cookie name",
    "cookieNameHint": "Empty: the provider's default.",
    "cookieLifetime": "Cookie lifetime, seconds",
    "every": "every {{seconds}}\u00a0s"
  }
}
